import { Component } from '@verndale/core';
import { ConditionalDisplay } from '../helpers/global';

class CostOfLiving extends Component {
  setupDefaults() {
    this.dom = {
      bars: this.el.querySelectorAll('.v-section-cost__li'),
      tooltips: this.el.querySelectorAll<HTMLElement>('.v-section-overview__tooltip'),
      icons: this.el.querySelectorAll<HTMLElement>('.v-section-overview__tooltip-icon')
    };
    if (ConditionalDisplay(this.el.id)) {
      this.el.style.display = 'none';
    }

    this.updateBarValues();
  }

  addListeners() {
    document.body.addEventListener('mousedown', e => {
      this.handleCloseTooltip(e);
    });

    document.body.addEventListener('touchend', e => {
      this.handleCloseTooltip(e);
    });

    (this.dom.icons as NodeListOf<HTMLElement>).forEach(trigger => {
      trigger.addEventListener('mouseover', e => {
        this.handleTriggerTooltip(e);
      });

      trigger.addEventListener('mouseout', () => {
        this.handleCloseAll();
      });
    });
  }

  handleTriggerTooltip(e: Event) {
    this.handleCloseAll();
    const trigger = (e.currentTarget as HTMLElement).closest('.v-section-cost__heading');
    const tooltip = trigger?.querySelector<HTMLElement>('.v-section-overview__tooltip');

    if (tooltip) {
      if (tooltip.style.display === 'block') {
        tooltip.style.display = 'none';
      } else {
        tooltip.style.display = 'block';
      }
    }
  }

  handleCloseAll() {
    (this.dom.tooltips as NodeListOf<HTMLElement>).forEach(tooltip => {
      tooltip.style.display = 'none';
    });
  }

  handleCloseTooltip(e: Event) {
    if (!(e.target as HTMLElement)?.closest('.v-section-cost__heading')) {
      this.handleCloseAll();
    }
  }

  updateBarValues() {
    (this.dom.bars as NodeListOf<HTMLElement>).forEach(bar => {
      const value = bar.dataset.value;
      const barFill = bar.querySelector('.v-section-cost__li-bar');
      if (barFill && value) {
        (barFill as HTMLElement).style.setProperty('inset-inline-end', `calc(100% - ${value})`);
      }
    });
  }
}

export default CostOfLiving;
